import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var mailboxId = route.query.mailboxId;
    var baseUrl = process.env.VUE_APP_BASE_URL;
    var dialogVisible = ref(false);
    var handleClose = ref(false);
    var srcList = ref([]);
    var srcList1 = ref([]); // 详情信息

    var fileList = ref([]);
    var detail = reactive({
      person: false
    }); //let dialogVisible = false
    //获取书记id

    var getshuji = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["isSecretary"]();

              case 2:
                _yield$globalProperti = _context.sent;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  detail.person = true;
                } else {
                  detail.person = false;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getshuji() {
        return _ref.apply(this, arguments);
      };
    }();

    getshuji();

    var getDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _fileList$value;

        var _yield$globalProperti2, data, img;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["emailDetail"](mailboxId);

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                Object.assign(detail, data);

                if (data.img) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", false);

              case 7:
                img = data.img;

                (_fileList$value = fileList.value).push.apply(_fileList$value, _toConsumableArray(img.split(",")));

                fileList.value.forEach(function (item) {
                  srcList.value.push(baseUrl + item);
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getDetail() {
        return _ref2.apply(this, arguments);
      };
    }();

    getDetail(); // 回复详情

    var replyImg = ref([]);
    var replyDetail = reactive({});

    var getreplyDetail = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _replyImg$value;

        var _yield$globalProperti3, data, img;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["replyDetail"](mailboxId);

              case 2:
                _yield$globalProperti3 = _context3.sent;
                data = _yield$globalProperti3.data;

                if (data) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", false);

              case 6:
                img = data.img;

                (_replyImg$value = replyImg.value).push.apply(_replyImg$value, _toConsumableArray(img.split(",")));

                Object.assign(replyDetail, data);
                replyImg.value.forEach(function (item) {
                  srcList1.value.push(baseUrl + item);
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getreplyDetail() {
        return _ref3.apply(this, arguments);
      };
    }();

    getreplyDetail(); //查看图片

    var imgs = ref();

    var getimg = function getimg(item) {
      dialogVisible.value = true;
      imgs.value = item;
      console.log(item);
    }; //我要写信


    var getLetter = function getLetter() {
      router.push({
        name: "reply",
        query: {
          mailboxId: mailboxId
        }
      });
    };

    return {
      detail: detail,
      route: route,
      router: router,
      getLetter: getLetter,
      replyDetail: replyDetail,
      fileList: fileList,
      replyImg: replyImg,
      baseUrl: baseUrl,
      dialogVisible: dialogVisible,
      handleClose: handleClose,
      getimg: getimg,
      imgs: imgs,
      srcList: srcList,
      srcList1: srcList1
    };
  }
});